import { Input, Select, Form, Collapse } from "antd";
import { useEffect } from "react";

export default function UserFilter({filters, setFilters}) {
    const [form] = Form.useForm();
    const onFinish = (values) => {
        setFilters({...filters, ...values});
        console.log({...filters, ...values});
    }
    useEffect(() => {
        form.setFieldsValue(filters);
    }, [filters]);
    return(
        <div>
            <Collapse
            items={[
                {
                    key: '1',
                    label: 'ფილტრები',
                    children: 
           <Form
           wrapperCol={{ span: 24 }}
           form={form}
            onFinish={onFinish}
            layout="inline"
            style={{ gap: 10 }}
            onValuesChange={onFinish}
            >
            <Form.Item 
            name="email"
            >
                <Input placeholder="ელექტრონული ფოსტა" autoComplete="none" type="email" />
            </Form.Item>
            <Form.Item name="first_name">
                <Input placeholder="სახელი" autoComplete="none" />
            </Form.Item>
            <Form.Item name="last_name">
                <Input placeholder="გვარი" autoComplete="none" />
            </Form.Item>
            <Form.Item name="is_active">
                <Select placeholder="სტატუსი" style={{ width: 200 }} options={[{label: 'ყველა', value: 'all'}, {label: 'აქტიური', value: true}, {label: 'არააქტიური', value: false}]} />
            </Form.Item>
            <Form.Item name="is_admin">
                <Select placeholder="მომხმარებლის ტიპი" style={{ width: 200 }} options={[{label: 'ყველა', value: 'all'}, {label: 'ადმინისტრატორი', value: true}, {label: 'მომხმარებელი', value: false}]} />
            </Form.Item>
           </Form>
        }
            ]}
        />
        </div>
    )
}